import { render, staticRenderFns } from "./ViewerControl.vue?vue&type=template&id=8bf20c1a&"
import script from "./ViewerControl.vue?vue&type=script&lang=js&"
export * from "./ViewerControl.vue?vue&type=script&lang=js&"
import style0 from "./ViewerControl.vue?vue&type=style&index=0&id=8bf20c1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports